import React from "react";
import { Select } from "components/select/index";

export interface IWebsiteBuilderSelectOption<T> {
  label: string;
  value: T;
}

export function renderWebsiteBuilderSelectOptions<T extends string | number>(options: IWebsiteBuilderSelectOption<T>[]) {
  const { Option } = Select;

  return (
    <>
      {options?.map((option, index) => (
        <Option key={index} value={option.value}>
          <span>{option.label}</span>
        </Option>
      ))}
    </>
  );
}
